<template>
    <div id="loading-box">
        <div class="mask" style="position: fixed; left: 0px; top: 0px; width: 100%; height: 100vh; background: rgba(0, 0, 0, 0.5); z-index: 2000"></div>
        <div
            data-v-9d7391f6=""
            class="bd"
            style="position: fixed; top: 50%; left: 50%; padding: 30px 50px; transform: translate(-50%, -50%); background: rgb(255, 255, 255); border-radius: 10px; text-align: center; z-index: 2001"
        >
            <img src="/assets/pwa/loading.svg" class="rotatebbb" style="width: 45px; height: 45px" />
            <p style="margin: 15px 0px 0px; font-size: 16px; color: #000">Carregando...</p>
        </div>
    </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.rotatebbb {
    -webkit-animation: loadingCircle-data 1s linear infinite;
    animation: loadingCircle-data 1s linear infinite;
}

@-webkit-keyframes loadingCircle-data {
    to {
        -webkit-transform: rotate(-1turn);
        transform: rotate(-1turn);
    }
}

@keyframes loadingCircle-data {
    to {
        -webkit-transform: rotate(-1turn);
        transform: rotate(-1turn);
    }
}
</style>
